import {useSelector} from 'react-redux';

function useUtilInformation() {
  const user = useSelector((state: any) => state.authentication.user);
  return {cwid: user.name, role: user.roles[0].role, token: user.token};
}

export default useUtilInformation;
